import {
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import Markdown from 'markdown-to-jsx'
import moment from 'moment'
import React from 'react'
import { NotificationDot } from 'src/components/NotificationDot/NotificationDot'
import TestId from 'src/components/TestId/TestId'
import {
  NotificationListModel,
  NotificationStatus,
} from 'src/models/notifications.models'
import { css } from 'styled-components'

interface HomeNotificationsTableItemProps {
  notification: NotificationListModel
  handleNotificationClick: (
    id: string,
    status: NotificationStatus,
    action: string,
  ) => void
}

const HomeNotificationsTableItem: React.FC<HomeNotificationsTableItemProps> = ({
  notification,
  handleNotificationClick,
}) => {
  const { action, body, timestamp, status, id } = notification

  return (
    <div
      onClick={(): void => handleNotificationClick(id, status, action)}
      onKeyPress={(): null => {
        return null
      }}
      tabIndex={0}
      role={'button'}
      css={css`
        display: flex;
        border-bottom: 1px solid ${styleConstants.colors.gray_light};
        padding: 16px 20px;
        cursor: pointer;
        &:hover {
          background-color: ${styleConstants.colors.gray_light};
        }
        &:last-child {
          border-bottom: 1px solid transparent;
        }
      `}
    >
      <div
        css={css`
          display: flex;
          flex-direction: column;
          width: 100%;
        `}
      >
        <div
          css={css`
            display: flex;
            margin-bottom: 2px;
          `}
        >
          <span
            css={css`
              ${getFontCss(
                12,
                themeConstants.colors.font_primary,
                styleConstants.fontFamilies.medium,
              )};
              margin-bottom: 5px;
            `}
          >
            {notification.subject}
          </span>
          <span
            css={css`
              ${getFontCss(
                10,
                styleConstants.colors.gray_darkest,
                styleConstants.fontFamilies.regular,
              )};
              margin-left: auto;
            `}
          >
            {moment(timestamp).format('M/D [at] h:mma')}
          </span>
        </div>
        <div
          css={css`
            display: flex;
            flex-direction: column;
            flex-grow: 1;
            padding-right: 10px;
          `}
        >
          <div
            css={css`
              position: relative;
            `}
          >
            {status === NotificationStatus.unread && (
              <NotificationDot
                css={css`
                  background-color: ${styleConstants.colors.red};
                  position: absolute;
                  width: 8px;
                  height: 8px;
                  top: 5px;
                  right: -5px;
                `}
              />
            )}
          </div>
          <div>
            <span
              css={css`
                ${getFontCss(
                  12,
                  themeConstants.colors.font_primary,
                  styleConstants.fontFamilies.regular,
                )};
                margin-bottom: 4px;
                white-space: pre-line;
              `}
            >
              <TestId testId={'activityNotificationItem'}>
                <Markdown options={{ disableParsingRawHTML: true }}>
                  {body}
                </Markdown>
              </TestId>
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HomeNotificationsTableItem
